import { deleteRequest, getRequest, postRequest } from '../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import { DtcMappingErrorsContext } from './context/context'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import Select from 'react-select'
import { downloadFileBlob, toTitleCase } from '../../../utils/common'
import DtcMappingErrorsRow from './DtcMappingErrorsRow'
import CheckBox from '../../common/CheckBox'
import DtcValidationButton from '../../DtcValidationButton'
import LinkWithStatus from '../../common/LinkWithStatus'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const DtcMappingErrors = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [dtcMappingErrorState, dtcMappingErrorDispatch] = useContext(
    DtcMappingErrorsContext
  )
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const [selectedVersions, setSelectedVersions] = useState([])
  const [versionOptions, setVersionOptions] = useState([])
  const [isSupported, setIsSupported] = useState(1)
  const [isMissConfigured, setIsMissConfigured] = useState(0)
  const [isMissingGraph, setIsMissingGraph] = useState(0)
  const [isMissingComponentInGraph, setIsMissingComponentInGraph] = useState(0)
  const [showFilters, setShowFilters] = useState(false)
  const [vinOptions, setVinOptions] = useState([])
  const [selectedVin, setSelectedVin] = useState()
  const [acronymOptions, setAcronymOptions] = useState([])
  const [selectedAcronym, setSelectedAcronym] = useState()
  const [progressMessage, setProgressMessage] = useState()

  const currentUrl = useRef(`/api/dtc_mapping_errors/?vehicle=${vehicle}`)

  useEffect(() => {
    getDtcMappingErrosList(null)
    getDtcMappingErrosVersions()
    getDtcMappingErrosVinsOptions()
    getDtcMappingErrosAcronymOptions()
    getDtcMappingErrosAcronymOptions()

    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / DTC Mapping Validation`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getDtcMappingErrosList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching DTC Mapping Validation`s Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    dtcMappingErrorDispatch({
      type: 'set_dtc_mapping_error_data',
      data: response.results,
    })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const getDtcMappingErrosVersions = async () => {
    let response = await getRequest(
      `/api/dtc_mapping_errors/versions/?vehicle=${vehicle}`
    )
    setVersionOptions(response.data)
  }

  const getDtcMappingErrosVinsOptions = async () => {
    let response = await getRequest(
      `/api/dtc_mapping_errors/vin/?vehicle=${vehicle}`
    )
    setVinOptions(response.data)
  }

  const getDtcMappingErrosAcronymOptions = async () => {
    let response = await getRequest(
      `/api/dtc_mapping_errors/acronym/?vehicle=${vehicle}`
    )
    setAcronymOptions(response.data)
  }

  const deleteDtcMappingError = async (selectedObject) => {
    if (
      window.confirm(
        `Are you sure want to delete ${selectedObject.dtc} ${selectedObject.acronym}`
      ) === true
    ) {
      let res = await deleteRequest(
        `/api/dtc_mapping_errors/delete/${vehicle}/${selectedObject.id}/`
      )
      getDtcMappingErrosList('')
    }
  }

  const downloadDtcMappingErrors = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: `Downloading DTC Mapping Validation file is in progress.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/dtc_mapping_errors/export/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=${isSupported}&is_misconfigured=${isMissConfigured}&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=${isMissingComponentInGraph}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}`,
      true,
      true
    )
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `dtc_mapping_errors-${vehicle}.csv`)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  const formatFilterUrl = (values) => {
    if (values) {
      let names = values?.map(function (item) {
        return item.value
      })
      return names.toString()
    } else {
      return ''
    }
  }
  return (
    <div className="w-full p-2">
      <form
        className="w-full space-y-2 pb-2 container m-auto"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=${isSupported}&is_misconfigured=${isMissConfigured}&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=${isMissingComponentInGraph}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}`
          getDtcMappingErrosList()
        }}
      >
        <div className="bg-tracer-dark-blue p-2 rounded px-4">
          <div className={`flex space-x-2 justify-between items-center`}>
            <div className="flex space-x-2 justify-between items-center w-full">
              <Select
                classNamePrefix="dtcs-filter"
                isMulti={true}
                value={selectedAcronym}
                options={acronymOptions.map((val) => ({
                  value: val,
                  label: val,
                }))}
                placeholder="Select Module Acronym"
                className="w-full cursor-pointer"
                onChange={(value) => {
                  setSelectedAcronym(value)
                }}
                isClearable={true}
              />
              <div className="flex items-center w-full">
                <div className="flex items-center w-full">
                  <InputText
                    name="search_value"
                    placeholder={`Search Dtc, Description`}
                    className={`w-auto`}
                    value={searchValue}
                    isFullSize={true}
                    type="search"
                    onChange={(value) => {
                      setSearchValue(value)
                    }}
                    isRequired={false}
                    wrapperClass={`pl-0`}
                  />
                </div>
              </div>

              <Select
                classNamePrefix="dtcs-filter"
                isMulti={false}
                value={selectedVersions}
                options={versionOptions.map((val) => ({
                  value: val,
                  label: val,
                }))}
                placeholder="Select Tracer Data Version"
                className=" w-full cursor-pointer"
                onChange={(value) => {
                  setSelectedVersions(value)
                }}
                isClearable={true}
              />

              <Select
                classNamePrefix="dtcs-filter"
                isMulti={true}
                value={selectedVin}
                options={vinOptions.map((val) => ({
                  value: val,
                  label: val,
                }))}
                placeholder="Select Vin"
                className="w-full cursor-pointer"
                onChange={(value) => {
                  setSelectedVin(value)
                }}
                isClearable={true}
              />

              <Button
                className={`cursor-pointer btn my-4 justify-end`}
                text={`Search`}
                onClick={() => {}}
              />
            </div>
          </div>
          <div className="flex space-x-2 justify-between items-center py-2 text-sm">
            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <CheckBox
                checked={isSupported === 1 ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    setIsSupported(0)
                    currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=0&is_misconfigured=${isMissConfigured}&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=${isMissingComponentInGraph}`
                  } else {
                    setIsSupported(1)
                    currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=1&is_misconfigured=${isMissConfigured}&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=${isMissingComponentInGraph}`
                  }
                  getDtcMappingErrosList()
                }}
              />
              <span className="text-white">MODULE INSTALLED</span>
            </div>
            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <CheckBox
                checked={isMissConfigured ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    setIsMissConfigured(0)
                    currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=${isSupported}&is_misconfigured=0&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=${isMissingComponentInGraph}`
                  } else {
                    setIsMissConfigured(1)
                    currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=${isSupported}&is_misconfigured=1&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=${isMissingComponentInGraph}`
                  }
                  getDtcMappingErrosList()
                }}
              />
              <span className="text-white">MISCONFIGURED</span>
            </div>

            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <CheckBox
                checked={isMissingComponentInGraph === 1 ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    setIsMissingComponentInGraph(0)
                    currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=${isSupported}&is_misconfigured=${isMissConfigured}&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=0`
                  } else {
                    setIsMissingComponentInGraph(1)
                    currentUrl.current = `/api/dtc_mapping_errors/?vehicle=${vehicle}&acronym=${formatFilterUrl(selectedAcronym)}&vin=${formatFilterUrl(selectedVin)}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_supported=${isSupported}&is_misconfigured=${isMissConfigured}&is_missing_graph=${isMissingGraph}&is_missing_component_in_graph=1`
                  }
                  getDtcMappingErrosList()
                }}
              />
              <span className="text-white">NO RESULTS DISPLAYED</span>
            </div>

            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <DtcValidationButton setProgressMessage={setProgressMessage} />
              <div className="flex justify-end">
                <LinkWithStatus
                  href={`/administration/dtc_mapping_errors`}
                  className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
                  title={`Export Dtc Mapping Errors`}
                  onClickFunc={() => {
                    downloadDtcMappingErrors()
                  }}
                />
              </div>
            </div>
          </div>
          {progressMessage && (
            <div className="flex space-x-2 justify-center items-center py-1 text-sm text-red-700 text-center">
              {progressMessage}
            </div>
          )}
        </div>
      </form>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">Acronym</div>
          <div className="flex w-3/12 pl-6 items-center">Dtc</div>
          <div className="flex w-2/12 pl-6 items-center">Vin</div>
          <div className="flex w-1/12 pl-6 items-center">Version</div>
          <div className="flex w-4/12 pl-2 items-center">Flags</div>
        </div>
      </div>
      {dtcMappingErrorState?.data?.map((dtc_mapping_error, index) => {
        return (
          <DtcMappingErrorsRow
            {...dtc_mapping_error}
            key={`dtc-mapping-error-${index}`}
            onEdit={() => {
              dtcMappingErrorDispatch({
                type: 'set_selected_dtc_mapping_error_data',
                data: { ...dtc_mapping_error, index: index },
              })
            }}
            onDelete={() => deleteDtcMappingError(dtc_mapping_error)}
          />
        )
      })}
      {dtcMappingErrorState?.data?.length < 1 && (
        <NoRecordsFound
          caption={'Dtc Mapping Errors Not Found'}
          loading={false}
        />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getDtcMappingErrosList(e)
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getDtcMappingErrosList(e)
          }}
        />
      </div>
    </div>
  )
}

export default DtcMappingErrors
